function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { mediaQueries } from "../../../theme";
var PALETTE_DATA = {
  primary: {
    borderLeftColor: 'blue.400'
  },
  success: {
    borderLeftColor: 'green.400'
  },
  danger: {
    borderLeftColor: 'red.400'
  },
  light: {
    borderLeftColor: 'grey.400'
  }
};
export var getToastItemStyles = function getToastItemStyles(_ref) {
  var palette = _ref.palette;
  var paletteData = PALETTE_DATA[palette];
  return _objectSpread(_defineProperty({
    backgroundColor: 'grey.900',
    gap: '24px',
    padding: '0px 24px',
    borderRadius: '4px',
    borderLeft: '6px',
    borderLeftStyle: 'solid',
    maxWidth: '620px',
    width: '100%'
  }, mediaQueries.md, {
    width: 'auto'
  }), paletteData);
};
export var getToastCloseButtonStyles = function getToastCloseButtonStyles() {
  return _defineProperty({
    display: 'none'
  }, mediaQueries.md, {
    display: 'flex'
  });
};